/* eslint-disable arrow-parens */
import { useState } from "react";
import { GoogleMap, InfoWindow, LoadScript, Marker, GoogleMapP } from "@react-google-maps/api";

const MapComponent = () => {
	const initialMarkers = [
		{
			position: {
				lat: 22.69243044556101,
				lng: 88.46534973208708
			},
			label: { color: "red", text: "mgm" },
			draggable: true
		}
		// {
		// 	position: {
		// 		lat: 32.3234,
		// 		lng: -96.8005
		// 	},
		// 	label: { color: "white", text: "P2" },
		// 	draggable: false
		// },
		// {
		// 	position: {
		// 		lat: 32.42528,
		// 		lng: -96.8007
		// 	},
		// 	label: { color: "white", text: "P3" },
		// 	draggable: true
		// }
	];

	const [activeInfoWindow, setActiveInfoWindow] = useState("");
	const [markers, setMarkers] = useState(initialMarkers);

	const containerStyle = {
		width: "100%",
		height: "400px"
	};

	const center = {
		lat: 22.692342,
		lng: 88.46528
	};

	const mapClicked = (event) => {
		// console.log(event.latLng.lat(), event.latLng.lng());
	};

	const markerClicked = (marker, index) => {
		setActiveInfoWindow(index);
		// console.log(marker, index);
	};

	const markerDragEnd = (event, index) => {
		// console.log(event.latLng.lat());
		// console.log(event.latLng.lng());
	};

	return (
		<LoadScript googleMapsApiKey="AIzaSyDLvfwCvlohejujpzGoN0zaJi-haC6MLj8">
			<GoogleMap mapContainerStyle={containerStyle} center={center} zoom={15} onClick={mapClicked}>
				{markers.map((marker, index) => (
					<Marker
						key={index}
						position={marker.position}
						label={marker.label}
						draggable={marker.draggable}
						onDragEnd={(event) => markerDragEnd(event, index)}
						onClick={(event) => markerClicked(marker, index)}
					>
						{activeInfoWindow === index && (
							<InfoWindow position={marker.position}>
								<b>
									{marker.position.lat}, {marker.position.lng}
								</b>
							</InfoWindow>
						)}
					</Marker>
				))}
			</GoogleMap>
		</LoadScript>
	);
};

export default MapComponent;
